import { CheckCircle2 } from "lucide-react";
import WhatsAppIcon from "./WhatsAppIcon";
import { Reveal } from "./Reveal";
import { useSite } from "@/lib/site";
import { waLink } from "@/lib/api";

const STR = {
  ar: {
    waBtn: "انضم عبر واتساب",
    formBtn: "إرسال استفسار عبر الموقع",
    cardText: "راسلنا الآن عبر واتساب، أو أرسل استفسارك عبر النموذج وسنتواصل معك.",
  },
  fr: {
    waBtn: "Rejoignez-nous via WhatsApp",
    formBtn: "Envoyer une demande via le site",
    cardText: "Écrivez-nous sur WhatsApp ou envoyez votre demande via le formulaire et nous vous contacterons.",
  },
};

export default function ForOwners({ content }) {
  const { lang } = useSite();
  const S = STR[lang] || STR.ar;
  const c = content?.owners;
  const wa = waLink(content?.contact?.whatsappNumber, content?.contact?.ownerMessage);
  return (
    <section id="owners" className="grain relative overflow-hidden bg-forest-900 py-24 sm:py-28">
      <div className="pointer-events-none absolute -bottom-24 left-1/4 h-[400px] w-[400px] rounded-full bg-gold/10 blur-[120px]" aria-hidden="true" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-14 px-5 lg:grid-cols-2 lg:gap-20">
        <div>
          <Reveal>
            <span className="text-sm font-semibold tracking-wide text-gold">{c?.eyebrow}</span>
            <h2 className="mt-2 font-head text-3xl font-extrabold leading-snug text-cream sm:text-4xl">
              {c?.title}
            </h2>
            <p className="mt-5 leading-loose text-cream/70">{c?.text}</p>
          </Reveal>
          <Reveal delay={0.12}>
            <ul className="mt-8 space-y-4">
              {(c?.bullets || []).map((b, i) => (
                <li key={i} className="flex items-center gap-3" data-testid={`owner-bullet-${i}`}>
                  <CheckCircle2 className="h-5 w-5 shrink-0 text-gold" />
                  <span className="text-cream/90">{b}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <div
            className="shine-sweep relative overflow-hidden rounded-[2rem] border border-gold/30 bg-forest-950/80 p-10 text-center shadow-[0_40px_80px_-40px_rgba(0,0,0,0.6)]"
            data-testid="owners-cta-card"
          >
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gold/15">
              <WhatsAppIcon className="h-8 w-8 text-gold" />
            </div>
            <h3 className="mt-6 font-head text-2xl font-extrabold text-cream">{c?.ctaText}</h3>
            <p className="mt-3 text-sm leading-relaxed text-cream/60">{S.cardText}</p>
            <div className="mt-8 flex flex-col gap-3">
              <a
                href={wa}
                target="_blank"
                rel="noreferrer"
                data-testid="owners-whatsapp-button"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-gold px-6 py-3.5 font-head font-extrabold text-forest-950 transition hover:-translate-y-0.5 hover:bg-gold-light"
              >
                <WhatsAppIcon className="h-5 w-5" />
                {S.waBtn}
              </a>
              <a
                href="#contact"
                data-testid="owners-form-link"
                className="inline-flex items-center justify-center rounded-full border border-cream/25 px-6 py-3.5 text-sm font-semibold text-cream transition hover:border-gold hover:text-gold"
              >
                {S.formBtn}
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
